export default __webpack_public_path__ + "static/media/Ct6.b70c3ad5.png";